import Cookies from 'js-cookie';

const cookieAnalyticsClientId = 'analytics-client-id';
const localStorageKey = 'circleciAnonymousId';

const generateCircleciAnonymousId = (): string | null => {
  const localStorageAnonymousId: string | null =
    localStorage.getItem(localStorageKey);
  const anonymousId: string | undefined =
    localStorageAnonymousId ||
    Cookies.get(cookieAnalyticsClientId) ||
    Date.now().toString();

  if (!localStorageAnonymousId) {
    localStorage.setItem(localStorageKey, anonymousId);
  }

  return anonymousId;
};

export default generateCircleciAnonymousId;
